import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import getResidientStatistics from '@api/statistics';
import { StatisticsData } from '@typings/Statistics';
import { ApiResponse } from '@typings/ApiResponse';
import './styles.scss';

interface ProgressDataProps {
  partnerCarehomeId: string;
  totalResidents: number;
}

const ProgressData: React.FC<ProgressDataProps> = ({
  partnerCarehomeId,
  totalResidents,
}) => {
  const [statistics, setStatistics] = useState<StatisticsData>({
    completed: 0,
    shared: 0,
    conversations: 0,
    self_completed: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const handleGetResidientStatistics = async () => {
      try {
        const response: ApiResponse<StatisticsData> =
          await getResidientStatistics(partnerCarehomeId);
        if (response && response.status === 'success') {
          setStatistics(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (partnerCarehomeId) {
      handleGetResidientStatistics();
    }
  }, [partnerCarehomeId]);

  const percentageCal = (value: number) => {
    if (value == null || !totalResidents || totalResidents === 0) {
      return '-';
    }
    const percentage = (value / totalResidents) * 100;

    return `${Math.floor(percentage)}%`;
  };

  return (
    <div>
      <h1 className="govuk-heading-l mt-10 govuk-bp:mt-14 homepage-acp-title py-2 px-3">
        Advance Care Planning - Progress data
      </h1>
      <p className="govuk-body">
        The data below provides a realtime snapshot on how your team is
        progressing with the current Advance Care Planning Case Load.
      </p>

      <div className="grid grid-cols-1 n:grid-cols-2 md:grid-cols-4 gap-4">
        <div className="md:text-center">
          <h3 className="govuk-heading-s">Completed</h3>
          <h1 className="govuk-heading-l">
            {percentageCal(statistics.completed)}
          </h1>
        </div>
        <div className="md:text-center">
          <h3 className="govuk-heading-s">Shared With Next Of Kin</h3>
          <h1 className="govuk-heading-l">
            {percentageCal(statistics.shared)}
          </h1>
        </div>
        <div className="md:text-center">
          <h3 className="govuk-heading-s">Conversations</h3>
          <h1 className="govuk-heading-l">
            {percentageCal(statistics.conversations)}
          </h1>
        </div>
        <div className="md:text-center">
          <h3 className="govuk-heading-s">Previously Completed</h3>
          <h1 className="govuk-heading-l">
            {percentageCal(statistics.self_completed)}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default ProgressData;
